export default "__VITE_ASSET__Coe7CEf0__"